//Library
import * as React from "react";
import { inject, observer } from "mobx-react";
import { QueryRoute } from "bernie-core";
import { withLocalization } from "bernie-l10n";
import { UitkExperimentaModuleMap } from "uitk-react-experimental-module-map";
import { ModuleMap, MapContext } from "./ModuleMap";
//types
import { MapsProps, MapsInjectedProps } from "./typings";
import { ClickAction } from "./MapsEnums";

//hooks
import { useFullscreenOpen } from "./hooks";

/**
 * Wrapper Map Component. Here we inject the stores and is rendered the call to action button
 * and is rendered the Main Map Component.
 * @param {MapsProps} props
 */
const MapsComponent: React.FC<MapsProps> = (props: MapsProps & MapsInjectedProps) => {
  const { sendUserToSRP, toggleShowFullscreenMap } = useFullscreenOpen(props);
  const shouldOpenMapInSRP = props.flexComponent.model.clickAction === ClickAction.SEND_TO_SRP;
  const mapCTAClickAction = shouldOpenMapInSRP ? sendUserToSRP : toggleShowFullscreenMap;

  return (
    <div
      className="Maps uitk-cell all-cell-1-1 uitk-cell all-y-padding-three"
      id={props.flexComponent.id}
      data-fm={props.flexComponent.fmId}
      data-fm-title-id={props.flexComponent.fmTitleId}
    >
      <UitkExperimentaModuleMap.CallToAction
        disabled={!props.hotels.allHotelsOnMap.length}
        staticMapAlt={props.l10n.formatText(
          "maps.hotel.multipleHotels.a11yLabel",
          props.context!.searchContext.location.name
        )}
        staticMapImgUrl={props.staticMap.signedUrl}
        callToActionText={props.l10n.formatText("maps.callToActionButtonShowMap")}
        onClick={mapCTAClickAction}
      />
      <MapContext.Provider
        value={{
          toggleShowFullscreenMap,
          sendUserToSRP,
          shouldOpenMapInSRP,
        }}
      >
        <QueryRoute query={{ pwaDialogMap: `open-${props.flexComponent.id}` }}>
          <ModuleMap {...props} />
        </QueryRoute>
      </MapContext.Provider>
    </div>
  );
};

export const Maps = withLocalization<MapsProps, React.FC<MapsProps>>(
  inject("analytics", "routeStore", "hotels", "staticMap", "poi")(observer(MapsComponent))
);

Maps.displayName = "Maps";

export default Maps;
